// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1nkR7","requiredAsterisk":"Info_requiredAsterisk__3xz52"};